// Module
var code = "<ngx-license-management [org-id]=\"$ctrl.$stateParams.orgId\" [my-account]=\"$ctrl.myAccount\"></ngx-license-management>";
// Exports
module.exports = code;